import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import Modal from '@modules/shared/components/reusable-components/model-popup';
import BlockUi from 'react-block-ui';
import { Loader } from 'react-loaders';

import { AssociationAdminLoginDetailsSelector } from '@redux/login/selectors';
import {
  CDPAdminDashboard,
  CDPAssociatedashboard
} from '@modules/chronic-disease-program/components/index';
import { APP_LABELS, CDP, STORAGE_KEYS } from '@config/app-config';
import SecureStorage from '@utilities/SecureStorage';
import { checkHipaaCertificate } from '@redux/chronic-disease-program/associate-dashboard/actions';

const CdpDashboard = props => {
  const [hippaCertificateStatus, setHipaaCertificateStatus] = useState(false);
  SecureStorage.setItem(STORAGE_KEYS.DASHBOARD_URL, '/cdp/dashboard');
  const { LoginUserData } = props;
  const loggedInUserRole = get(LoginUserData, 'user.role[0]', null);
  const { handleCheckHipaaCertificate } = props;
  const [showConfirmation, setShowConfirmation] = useState(true);
  const [confirmAttestation, setConfimAttestation] = useState(false);
  const localHippaaAttestation = sessionStorage.getItem(
    STORAGE_KEYS.HIPAA_CERTIFICATE
  );
  const [loader, setLoader] = useState(false);

  const getCheckHipaaCertificate = async () => {
    setLoader(true);
    const response = await handleCheckHipaaCertificate();
    if (response) {
      setHipaaCertificateStatus(response.data);
      setShowConfirmation(false);
      sessionStorage.setItem(STORAGE_KEYS.HIPAA_CERTIFICATE, response.data);
      setLoader(false);
    }
  };

  const loadComponent = () => {
    debugger;
    if (hippaCertificateStatus || localHippaaAttestation === 'true') {
      switch (loggedInUserRole) {
        case APP_LABELS.YUSA_DATA_STEWARD:
          return <CDPAdminDashboard />;
        case APP_LABELS.CEO_DATA_STEWARD:
        case APP_LABELS.BRANCH_DATA_STEWARD:
        case APP_LABELS.ASSOCIATION_DATA_STEWARD:
          return <CDPAssociatedashboard />;
        default:
          return <div />;
      }
    } else {
      return <></>;
    }
  };

  // DO NOT DELETE THIS FUNCTION. IT IS COMMENTED OUT FOR NOW BECAUSE THE NEW HIPAA CERTIFICATE CHECK IS TEMPRORARY. IT WILL BE USED IN THE FUTURE.
  // const hippaExpiryMessage = () => {
  //   return (
  //     <div className="container">
  //       <div className="row my-5 pt-5 justify-content-center">
  //         <div className="col-10">
  //           <div className="card ymca-primary-card d-flex align-items-center justify-content-center h-100 mt-2">
  //             <h2 className="ymca-error-head">{CDP.DASHBOARD.hippaExpiry}</h2>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  // const handleConfirmAttestation = async () => {
  //   await getCheckHipaaCertificate();
  // };

  const attestationMessage = () => (
    <div className="container">
      <div className="row" style={{ fontSize: '16px' }}>
        Before accessing the Chronic Disease Program, you must attest that you
        have valid HIPAA certification.
      </div>
      <div className="row pt-3" style={{ fontSize: '16px' }}>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="flexCheckDefault"
            onChange={() => setConfimAttestation(true)}
          />
          <label className="form-check-label" htmlFor="flexCheckDefault">
            I acknowledge that I have valid HIPAA certification and understand
            that by selecting Continue, I am attesting that this information is
            true.
          </label>
        </div>
      </div>
      <div className="row">
        <button
          disabled={!confirmAttestation}
          className="btn btn-primary ymca-btn-primary mt-3"
          type="button"
          onClick={() => {
            getCheckHipaaCertificate();
          }}
        >
          Continue
        </button>
      </div>
    </div>
  );

  const renderComponent = () => {
    if (showConfirmation && localHippaaAttestation !== 'true') {
      return (
        <>
          <div className="cdp-modal-overlay">
            <div className="modal d-block" tabIndex="-1" aria-hidden="true">
              <div className="modal-dialog ymca-modal view-details-modal-dialog">
                <div className="modal-content">
                  <div className="modal-header p-0">
                    <div className="ymca-black-sub-heading">
                      HIPAA Certification Attestation
                    </div>
                  </div>
                  <div className="modal-body px-0">{attestationMessage()}</div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
    return loadComponent();
  };

  return (
    <>
      <BlockUi
        blocking={loader}
        message="Loading, please wait"
        loader={<Loader active type="semi-circle-spin" />}
      >
        {renderComponent()}
      </BlockUi>
    </>
  );
};

CdpDashboard.propTypes = {
  handleCheckHipaaCertificate: PropTypes.func.isRequired,
  LoginUserData: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapStateToProps = state => ({
  LoginUserData: AssociationAdminLoginDetailsSelector(state)
});

const mapDispatchToProps = {
  handleCheckHipaaCertificate: checkHipaaCertificate
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CdpDashboard));
